import { defaultPanelBiParams } from './defaultBiParams'
import { canBeReadByNonAdmin } from '@wix/wix-data-client-common/dist/esm/business-logic/collections/permissions'
import openConfirmationPanel from '@wix/wix-data-client-common/dist/esm/panels/error-panel/openConfirmationPanel'

export default async ({
  editorSdkProxy,
  origin,
  collectionId,
  namespace: dbDriverNamespace,
  pageRef,
  appApi,
  collectionsApi,
  logger,
  i18n,
  originatesFromDynamicPagesIntro,
  isSiteWithoutCollections,
  isFirstTimeExperience,
}) => {
  const originatesFromTooManyPagesSuggestion =
    origin === 'too_many_pages_suggestion'

  const originatesFromPagesPanel = origin === 'pagesPanel'
  const originatesFromPagesTree = origin === 'idePagesTree'
  const orignatesFromQuickAddMenu = origin === 'pagesPanel/QuickAddMenu'

  const originatesFromStaticToDynamic = Boolean(pageRef)

  const siteWithoutCollections = await isSiteWithoutCollections()

  if (orignatesFromQuickAddMenu) {
    if (siteWithoutCollections) {
      return appApi.openNewDynamicPageIntroPanel({
        origin,
      })
    } else {
      return appApi.openAddDynamicPagePanelV5({
        origin,
        isFirstTimeExperience,
        canChangeCollection: true,
      })
    }
  }

  if (originatesFromTooManyPagesSuggestion) {
    return appApi.openAddDynamicPagePanelV4({
      origin,
      isFirstTimeExperience,
    })
  }

  if (
    dbDriverNamespace &&
    (originatesFromPagesTree || originatesFromPagesPanel)
  ) {
    const collections = (
      await collectionsApi.getAll({ includeHiddenAppCollections: true })
    )
      .filter(({ namespace }) => namespace === dbDriverNamespace)
      .filter(canBeReadByNonAdmin)

    if (collections.length === 0) {
      return openConfirmationPanel({
        editorSdkProxy,
        logger,
        headerText: i18n.t(
          'Dynamic_Pages_Warning_Cannot_Add_Dynamic_Page_Title',
        ),
        descriptionText: i18n.t(
          'Dynamic_Pages_Warning_Cannot_Add_Dynamic_Page_Text',
        ),
        mainActionText: i18n.t(
          'Dynamic_Pages_Warning_Cannot_Add_Dynamic_Page_Button',
        ),
      })
    }

    if (collections.length === 1) {
      const [collection] = collections

      return appApi.addDefaultDynamicItemPage({
        collectionId: collection.id,
        origin,
        panelName: 'NEW_DYNAMIC_PAGE',
      })
    }

    return appApi.openAddDynamicPagePanelV4({
      origin,
    })
  }

  if (collectionId) {
    return appApi.addDefaultDynamicItemPage({
      collectionId,
      origin,
      panelName: defaultPanelBiParams.panel_name,
    })
  }

  if (originatesFromDynamicPagesIntro && !originatesFromStaticToDynamic) {
    return appApi.openAddDynamicPagePanelV4({
      origin: 'dynamicPagesIntro',
    })
  }

  if (originatesFromStaticToDynamic) {
    return appApi.openConvertToDynamicPagePanelV2({ pageRef, origin })
  }

  if (siteWithoutCollections) {
    return appApi.openCreateCollectionPanel({ origin })
  }

  return appApi.openAddDynamicPagePanelV4({
    origin,
  })
}
